import { createFileRoute } from "@tanstack/react-router";
import {
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { LinkedOrgBankSelector } from "@/routes/_authed/_org/transactions/reimbursements/-components/linked-bank-selector";

export const Route = createFileRoute(
  "/_authed/_org/transactions/reimbursements/settings",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="flex h-full flex-col">
      <SheetHeader className="border-b p-6">
        <SheetTitle className="flex flex-row items-center">
          Reimbursement Settings
        </SheetTitle>

        <SheetDescription>
          Manage your reimbursement integration by setting custom coding rules
          and configuring your chart of accounts
        </SheetDescription>
      </SheetHeader>

      <div className="flex grow flex-col p-6">
        <LinkedOrgBankSelector />
      </div>
    </div>
  );
}
